import React from "react";
import styled from '@emotion/styled';
import { Grid, Typography } from '@mui/material';
import { DataGridPremium, GridValidRowModel } from '@mui/x-data-grid-premium';

export const CollapsibleDataTable = styled(DataGridPremium)(() => ({
    color: '#fff',
    backgroundColor: '#1B1C1C',
    borderRadius: '8px',
    fontSize: '16px',
    border: '1.5px solid #999999',
    '& .MuiDataGrid-columnHeaders': {
    },
    '& .MuiDataGrid-cell': {
      borderRight: '1px solid #5E5E5E',
      borderLeft: '1px solid #5E5E5E',
      borderTop: '0px',
      borderBottom: '0px'
    },
    '& .MuiDataGrid-row': {
        '&:nth-of-type(2n - 1)': {
          backgroundColor: '#232424'
        },
        borderTop: '1px solid #5E5E5E',
        borderBottom: '1px solid #5E5E5E'
    },    
    '& .MuiIconButton-root': {
      color: '#fff'
    },
    '& .MuiDataGrid-footerContainer': {
      borderTop: '1px solid #999999'
    },
    '& .MuiDataGrid-iconSeparator': {
      color: '#999999'
    },
    '& .MuiDataGrid-overlay': {
      backgroundColor: '#1B1C1C'
    },
    '& .MuiDataGrid-row:hover': {
      backgroundColor: '#333333'
    },
    '& .MuiTablePagination-selectLabel': {
      margin: '0'
    },
    '& .MuiDataGrid-virtualScroller::-webkit-scrollbar': {
      width: '10px',
      height: '10px',
      background: '#3e3e3e'
    },
    '& .MuiDataGrid-virtualScroller::-webkit-scrollbar-track': {
      boxShadow: 'inset 0 0 5px #3e3e3e',
      borderRadius: '10px'
    },
    '& .MuiDataGrid-virtualScroller::-webkit-scrollbar-thumb': {
      background: '#fff',
      width: '10px',
      borderRadius: '7px'
    },
    '& .MuiDataGrid-virtualScroller': {
      overflow: 'auto'
    },
    '& .MuiDataGrid-columnHeaderTitleContainerContent': {
      display: 'contents'
    }
  }));

  export interface DetailPanelComponentProps extends GridValidRowModel {
    descriptionLabel: string;
 }

  export const DetailPanelComponent: React.FC<DetailPanelComponentProps> = ({ ...row }) => {

    return (
      <Grid 
        container 
        display={'flex'} 
        direction={'row'}  
        style={{padding: '20px'}}  
        spacing={5}
        justifyContent={'start'}               
      >
        <Grid item>
          <Typography>{`${row.descriptionLabel}: `}</Typography>
        </Grid> 
        <Grid item>
          <Typography>
              {row!.description}
          </Typography>
        </Grid>                     
      </Grid>          
    );
  };
 